import { useEffect, useState } from "react";
import { logOut } from "../../config/user";
import { handleApiErrorResponses } from "../../utils/ApisErrorHandling";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import { AddUserApi } from "../../services/AdminServices";
import { emailRegex, passwordRegex } from "../../utils/formUtils";
import CloseIcon from "../../assets/hospitalCloseIcon.svg";
import RightArrow from "../../assets/rightArrowWhite.svg";
import { CircularProgress } from "@mui/material";
import Select from "react-select";
const validationSchema = Yup.object().shape({
  fullName: Yup.string()
    .required("Name is required")
    .min(2, "Name must be at least 2 characters"),
  email: Yup.string()
    .matches(emailRegex, "Invalid Email Address")
    .required("Email is required"),

  phoneNumber: Yup.string()
    .required("Phone number is required")
    .matches(/^\+91\d{10}$/, "Phone number must be 10 digits"),

  password: Yup.string()
    .required("Password is required")
    .matches(
      passwordRegex,
      "Must Contain 8 Characters, One Uppercase, One Lowercase, One Number and One Special Case Character"
    ),

  age: Yup.number()
    .typeError("Age must be a valid number")
    .required("Age is required")
    .min(18, "Age cannot be less than 18")
    .max(130, "Age cannot be more than 130"),
});

const AddSubAdmin = ({ setOpen, getSubAdminList }) => {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const handleSubmit = async (values) => {
    setIsSubmitting(true);
    try {
      const response = await AddUserApi(values);
      if (response.status === 200) {
        window.alert("Subadmin Created Successfully");
      }
      await getSubAdminList();
      setOpen(null);
    } catch (error) {
      handleApiErrorResponses(error);
    }
    setIsSubmitting(false);
  };
  useEffect(() => {
    document.body.style.overflow = "hidden";
    return () => {
      document.body.style.overflow = "auto";
    };
  }, []);
  return (
    <div className="fixed top-0 left-0 w-screen h-screen bg-[#017C7180] flex justify-center items-center">
      <div className="relative w-[70%] h-fit bg-white p-10 rounded-[30px]">
        <div
          className="absolute top-5 right-5 cursor-pointer"
          onClick={() => setOpen(false)}
        >
          <img src={CloseIcon} alt="close-icon" />
        </div>
        <div className="text-[40px] 2xl:text-[50px] -tracking-[7%] leading-[32px]">
          Enter all Sub Admin details and Save
        </div>
        <div
          style={{
            border: "1px solid #D4D4D4",
          }}
          className="mt-[30px] 2xl:mt-[40px] mb-[40px] 2xl:mb-[74px]"
        />
        <div className="text-[40px] 2xl:text-[50px] -tracking-[7%] leading-[32px] mb-10">
          Sub Admin
        </div>

        <div>
          <Formik
            initialValues={{
              fullName: "",
              email: "",
              phoneNumber: "",
              password: "",
              age: "",
              gender: "",
            }}
            validationSchema={validationSchema}
            onSubmit={(values, { setSubmitting }) => {
              handleSubmit(values);
              setSubmitting(false);
            }}
            validateOnChange={true}
            validateOnBlur={false}
          >
            {({ values, setFieldValue, errors, touched }) => (
              <Form>
                <div className="flex justify-between items-end">
                  <div className="w-[60%] flex flex-wrap gap-x-[2%] gap-y-8 justify-between">
                    <label htmlFor="fullname" className="w-[48%]">
                      <Field
                        name="fullName"
                        placeholder="Enter Full Name"
                        style={{ border: "1px solid #d4d4d4" }}
                        className="w-full rounded-full p-5 box-border "
                        onInput={(e) => {
                          e.target.value = e.target.value.replace(
                            /[^A-Za-z ]/g,
                            ""
                          );
                        }}
                      />
                      <ErrorMessage
                        name="fullName"
                        component="div"
                        className="field-error"
                      />
                    </label>
                    <label htmlFor="phoneNumber" className="w-[48%]">
                      <Field
                        type="string"
                        name="phoneNumber"
                        max={13}
                        style={{ border: "1px solid #d4d4d4" }}
                        className="w-full rounded-full p-5 box-border"
                        placeholder="Enter Phone Number"
                        onInput={(e) => {
                          const value = e.target.value;
                          if (!value.startsWith("+91")) {
                            e.target.value =
                              "+91" +
                              value.replace(/\D/g, "").replace(/^91/, "");
                          } else {
                            e.target.value =
                              "+91" + value.slice(3).replace(/\D/g, "");
                          }
                        }}
                      />
                      <ErrorMessage
                        name="phoneNumber"
                        component="div"
                        className="field-error"
                      />
                    </label>
                    <label htmlFor="email" className="w-[48%]">
                      <Field
                        type="text"
                        name="email"
                        style={{ border: "1px solid #d4d4d4" }}
                        className="w-full rounded-full p-5 box-border"
                        placeholder="Enter email address"
                        onChange={(e) => {
                          setFieldValue("email", e.target.value);
                        }}
                      />
                      <ErrorMessage
                        name="email"
                        component="div"
                        className="field-error"
                      />
                    </label>{" "}
                    <label htmlFor="password" className="w-[48%]">
                      <Field
                        type="password"
                        name="password"
                        style={{ border: "1px solid #d4d4d4" }}
                        className="w-full rounded-full p-5 box-border"
                        placeholder="Enter password"
                      />
                      <ErrorMessage
                        name="password"
                        component="div"
                        className="field-error"
                      />
                    </label>
                    <label htmlFor="age" className="w-[48%]">
                      <Field
                        name="age"
                        placeholder="Enter Age"
                        maxLength={3} // because age cannot exceed 3 digits (130)
                        className="w-full rounded-full p-5 box-border"
                        style={{ border: "1px solid #d4d4d4" }}
                        onInput={(e) => {
                          e.target.value = e.target.value.replace(
                            /[^0-9]/g,
                            ""
                          );
                        }}
                      />
                      <ErrorMessage
                        name="age"
                        component="div"
                        className="field-error"
                      />
                    </label>
                    <label htmlFor="gender" className="w-[48%]">
                      <Field
                        as="select"
                        name="gender"
                        style={{ border: "1px solid #d4d4d4" }}
                        className="w-full rounded-full p-5 bg-white "
                      >
                        <option value="" disabled>
                          Select Gender
                        </option>
                        <option value="male">Male</option>
                        <option value="female">Female</option>
                        <option value="other">Other</option>
                      </Field>

                      <ErrorMessage
                        name="gender"
                        component="div"
                        className="field-error text-red-500 text-sm mt-1"
                      />
                    </label>
                  </div>
                  <div style={{ marginTop: "24px" }}>
                    {isSubmitting ? (
                      <CircularProgress />
                    ) : (
                      <button
                        type="submit"
                        disabled={isSubmitting}
                        style={{ border: "none", cursor: "pointer" }}
                        className="flex items-center gap-4 text-sm text-white bg-[#017C71] leading-[21.7px] -tracking-[3%] px-5 py-[15px] rounded-full"
                      >
                        SAVE SUB-ADMIN
                        <img src={RightArrow} alt="right-arrow" />
                      </button>
                    )}
                  </div>
                </div>
              </Form>
            )}
          </Formik>
        </div>
      </div>
    </div>
  );
};

export default AddSubAdmin;
